import { lazy } from 'react';

export const OperateLogPage = lazy(() => import('./operate-log-page'));

export const LoginLogPage = lazy(() => import('./login-log-page'));
